module.exports = __webpack_public_path__ + "media/images/icon-menu@3x-5d66f84edef063ec1973ce7f5740827e.png";